import { render, staticRenderFns } from "./Agents.vue?vue&type=template&id=3b3154d6&"
import script from "./Agents.vue?vue&type=script&lang=ts&"
export * from "./Agents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports